{
    "name": "03 Bonus Booster",
    "title": "ChainBonus",
    "description": "ComboChainUpgradeDescription1",
    "stat": 7,
    "lockFlag": 22
}
